import React from 'react';
import { Box, Grid } from '@mui/material';
import {
  AutoAwesome as MatchingIcon,
  Leaderboard as RankingIcon,
  Dashboard as TrackingIcon,
  Groups as MultiRecruiterIcon,
  Work as JobPostingIcon,
  School as ReadinessIcon,
} from '@mui/icons-material';
import SectionContainer from '../shared/SectionContainer';
import FeatureCard from '../shared/FeatureCard';
import LandingCtaButton from '../shared/LandingCtaButton';
import { ATS_FEATURES, CTAS } from '../landingContent';

const ATS_ICONS = [
  MatchingIcon,
  RankingIcon,
  TrackingIcon,
  MultiRecruiterIcon,
  JobPostingIcon,
  ReadinessIcon,
];

const AtsFeaturesSection = () => (
  <SectionContainer
    id="recruiters"
    title="Built for Modern Recruiting Teams"
    subtitle="Streamline your hiring pipeline with AI-powered tools designed for staffing agencies and in-house recruiters."
    titleId="recruiters-heading"
    bgcolor="grey.50"
  >
    <Grid container spacing={3}>
      {ATS_FEATURES.map((feature, index) => {
        const Icon = ATS_ICONS[index];
        return (
          <Grid item xs={12} sm={6} md={4} key={feature.title}>
            <FeatureCard
              title={feature.title}
              description={feature.description}
              icon={<Icon sx={{ fontSize: 36 }} />}
            />
          </Grid>
        );
      })}
    </Grid>
    <Box sx={{ textAlign: 'center', mt: 5 }}>
      <LandingCtaButton
        to={CTAS.demo.to}
        label={CTAS.demo.label}
        variant={CTAS.demo.variant}
      />
    </Box>
  </SectionContainer>
);

export default AtsFeaturesSection;
